<button mat-icon-button [matMenuTriggerFor]="menu" class="user-button">
  <span>{{ displayedName }}</span>
</button>

<mat-menu #menu="matMenu">
  <ebw-user-profile-menu
    [userInfo]="userInfo"
    [urlChangePassword]="urlPassword"
    [userId]="userId"
    [profilePageRoute]="profilePageRoute"
    [homePageRoute]="'/home'"
  >
  </ebw-user-profile-menu>

  <button mat-button [matTooltip]="'common.logout' | translate" (click)="logout($event)" class="w-100 text-left">
    {{ 'user_profile.menu.logout' | translate }}
  </button>
</mat-menu>
